import React, {useCallback, useState} from "react";
import ModalV2 from "../../../components/portal/ModalV2";
import {apiV2, platformAPI} from "../../../api/axiosConfig";
import {isAxiosError, AxiosInstance} from "axios";
import {IconButton} from "../../../features/management-v2/import/inputs";
import DeleteIcon from "@mui/icons-material/Delete";
import {noop} from "../../../lib/misc/noop";

export function useDeleteModal(
    itemType: string,
    itemName: string,
    endpoint: string,
    afterDelete: () => void = noop,
    api: AxiosInstance = apiV2,
) {

    const [showModal, setShowModal] = useState(false);
    const openDeleteModal = () => setShowModal(true);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>();


    const handleDelete = useCallback(() => {
        setError(undefined);
        setLoading(true);

        api.delete(`${endpoint}`).then(() => {
            setShowModal(false);
            afterDelete();
        }).catch((err) => {
            if (isAxiosError(err)) {
                const errorMsg = err?.response?.data?.error ?? "An error has occurred";
                setError(errorMsg);
            } else {
                setError("An error has occurred");
            }
        }).finally(() => {
            setLoading(false);
        })


    }, [endpoint]);

    const DeleteModal = useCallback(() => {
        return (
            <ModalV2 open={showModal} setOpen={setShowModal}>
                <h2 className="text-lg font-bold">Delete {itemType} {itemName}</h2>

                <p>Please confirm you want to delete this item.</p>
                <IconButton text="Delete" color="red" onClick={handleDelete} loading={loading} icon={<DeleteIcon/>}/>
                {error && <p className="text-center text-red">{error}</p>}
            </ModalV2>
        )


    }, [itemType, itemName, showModal, handleDelete, error, loading]);


    return {
        DeleteModal,
        openDeleteModal,
    }

}

export function usePlatformDeleteModal(
    itemType: string,
    itemName: string,
    endpoint: string,
    afterDelete: () => void = noop,
) {
    return useDeleteModal(itemType, itemName, endpoint, afterDelete, platformAPI);
}